export default "__VITE_ASSET__9MW5zXWO__"